import { MdOutlineLocationOn } from "react-icons/md";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="absolute top-[150px] right-[-28px]"
      style={{ display: "block" }}
      onClick={onClick}
    >
      <FaAngleRight className="w-6 h-10 cursor-pointer" />
    </div>
  );
}
function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="absolute bottom-[205px] left-[-50px]" style={{ display: "block" }} onClick={onClick}>
      <FaAngleLeft className="w-6 h-10 cursor-pointer" />
    </div>
  );
}
const BusinessSlider = () => {
  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    speed: 500,
    cssEase: "linear",
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  return (
    <div className="py-12">
      <Slider {...settings}>
        <div >
          <div className="flex h-[388px] w-[309px] flex-col justify-center">
            <div>
              <img
                className="h-[308px] rounded-md"
                src="assets/images/business_details/buzzimg.png"
                alt="auctionimg1"
              />
            </div>
            <div className="mt-3 flex w-[309px] flex-col justify-center">
              <h5 className="font-pop text-xl font-medium text-primary">
                Buz Plumbing
              </h5>
              <div className="mt-2 flex items-center gap-x-3">
                <MdOutlineLocationOn className="h-5 w-5 text-[#D91F2A]" />
                <p className="font-regular font-pop text-xl">Pretoria </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex h-[388px] w-[309px] flex-col justify-center">
            <div>
              <img
                className="h-[308px] rounded-md"
                src="assets/images/business_details/kathimg.png"
                alt="auctionimg1"
              />
            </div>
            <div className="mt-3 flex w-[309px] flex-col justify-center">
              <h5 className="font-pop text-xl font-medium text-primary">
                Kathmandu (Pty)Ltd
              </h5>
              <div className="mt-2 flex items-center gap-x-3">
                <MdOutlineLocationOn className="h-5 w-5 text-[#D91F2A]" />
                <p className="font-regular font-pop text-xl">Pretoria </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex h-[388px] w-[309px] flex-col justify-center">
            <div>
              <img
                className="h-[308px] rounded-md"
                src="assets/images/business_details/mobimg.png"
                alt="auctionimg1"
              />
            </div>
            <div className="mt-3 flex w-[309px] flex-col justify-center">
              <h5 className="font-pop text-xl font-medium text-primary">
                Mobile City
              </h5>
              <div className="mt-2 flex items-center gap-x-3">
                <MdOutlineLocationOn className="h-5 w-5 text-[#D91F2A]" />
                <p className="font-regular font-pop text-xl">Bedfordview </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex h-[388px] w-[309px] flex-col justify-center">
            <div>
              <img
                className="h-[308px] rounded-md"
                src="assets/images/business_details/outimg.png"
                alt="auctionimg1"
              />
            </div>
            <div className="mt-3 flex w-[309px] flex-col justify-center">
              <h5 className="font-pop text-xl font-medium text-primary">
                Bivouac outdoor
              </h5>
              <div className="mt-2 flex items-center gap-x-3">
                <MdOutlineLocationOn className="h-5 w-5 text-[#D91F2A]" />
                <p className="font-regular font-pop text-xl">Capetown </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <img
            className="h-[308px] rounded-md"
            src="assets/images/business_details/outimg.png"
            alt="auctionimg1"
          />
        </div>
      </Slider>
    </div>
  );
};

export default BusinessSlider;
